import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CardGroup, Container } from "react-bootstrap";
import { apiRecupActualitesColidee } from "../../../api/ApiColidee";
import { apiGetProcesses } from "../../../api/ApiProcess";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import BlocActualitesThumbnail from "./BlocActualitesThumbnail";

const ComponentActualites = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [actualites, setActualites] = useState(0);

  const recupActualites = async () => {
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    var listeEspaces = [];
    resProcesses.data.map((process) => (listeEspaces = listeEspaces.concat(process.espaces)));
    listeEspaces = listeEspaces.filter((x, i, a) => a.indexOf(x) === i);

    const form = new FormData();
    form.append("espacesSouhaites", listeEspaces.join(","));

    const resActualites = await apiRecupActualitesColidee(ReduxToken, form);
    if (resActualites.data) {
      setActualites(resActualites.data);
    }
  };

  const BlocActualite = () => {
    return (
      <CardGroup className="disableOverflowContent" id={"overflowActualites"}>
        {actualites.map((actualite, index) => (
          <BlocActualitesThumbnail actualiteObject={actualite} key={index} />
        ))}
      </CardGroup>
    );
  };

  useEffect(() => {
    recupActualites();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {actualites.length > 0 && ReduxInstance.modulesActives.includes("actualite") && (
        <Container className="mt-5" fluid>
          <ComponentSousTitle
            nom={t("public.filtres.filtre11")}
            overflowID={"overflowActualites"}
            overflowDeplieAuDepart={true}
          />
          <BlocActualite />
        </Container>
      )}
    </>
  );
};

export default ComponentActualites;
